import { useEffect, useState, useCallback } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Estimator from "@/components/site/Estimator";
import About from "@/components/site/About";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function App() {
  const [enquiryService, setEnquiryService] = useState("");

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  const scrollTo = useCallback((id) => {
    if (window.__lenis) {
      window.__lenis.scrollTo(id, { offset: -72, duration: 1.4 });
    } else {
      document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  const enquireFor = useCallback(
    (service) => {
      setEnquiryService(service);
      scrollTo("#contact");
    },
    [scrollTo]
  );

  return (
    <div className="bg-[#0A0E17] min-h-screen" data-testid="app-root">
      <Navbar scrollTo={scrollTo} />
      <main>
        <Hero scrollTo={scrollTo} />
        <Marquee />
        <Services onEnquire={enquireFor} />
        <Estimator onRequestQuote={enquireFor} />
        <About />
        <Contact preselectedService={enquiryService} />
      </main>
      <Footer scrollTo={scrollTo} />
      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}
